"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useBigPointsCalculatorContext = exports.default = exports.BigPointsCalculatorContext = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _utilities = _interopRequireDefault(require("../../utilities"));
var _BigPointsCalculator = _interopRequireWildcard(require("./BigPointsCalculator.proptypes"));
var _constant = require("./constant");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var getFare = function getFare(currency, totalAmount, baseFare, tax) {
  var fareInfo = _BigPointsCalculator.FareInfo;
  fareInfo.currency = currency;
  fareInfo.totalAmount = totalAmount;
  fareInfo.strikeThrough = _constant.ZERO_PRICE;
  fareInfo.exclusive = _constant.ZERO_PRICE;
  var feeBreakDown = _BigPointsCalculator.FeeBreakdown;
  feeBreakDown.amount = baseFare;
  feeBreakDown.name = _constant.BPC_CONSTANTS.baseFareName;
  feeBreakDown.type = _constant.BPC_CONSTANTS.baseFareType;
  var feeBreakdownArray = [];
  feeBreakdownArray.push(feeBreakDown);
  var feeCharge = _BigPointsCalculator.FeeCharge;
  feeCharge.totalAmount = baseFare;
  feeCharge.breakdown = feeBreakdownArray;
  var taxBreakDown = _BigPointsCalculator.TaxBreakdown;
  taxBreakDown.amount = tax;
  taxBreakDown.name = _constant.BPC_CONSTANTS.taxName;
  taxBreakDown.type = _constant.BPC_CONSTANTS.taxType;
  var taxBreakdownArray = [];
  taxBreakdownArray.push(taxBreakDown);
  var taxCharge = _BigPointsCalculator.TaxCharge;
  taxCharge.totalAmount = tax;
  taxCharge.breakdown = taxBreakdownArray;
  fareInfo.fee = feeCharge;
  fareInfo.tax = taxCharge;
  var fare = _BigPointsCalculator.Fare;
  fare.invoiceCurrency = fareInfo;
  return fare;
};
var getPaymentInfo = function getPaymentInfo(currency, totalAmount) {
  var payment = _BigPointsCalculator.Payments;
  payment.amount = totalAmount;
  payment.transactionDate = _constant.BPC_CONSTANTS.date;
  payment.paymentStatus = _constant.BPC_CONSTANTS.paymentStatus;
  payment.processingFee = _constant.ZERO_PRICE;
  payment.currency = currency;
  payment.transactionId = _constant.BPC_CONSTANTS.constantId;
  payment.referenceId = _constant.BPC_CONSTANTS.constantId;
  payment.paymentMethod = _constant.BPC_CONSTANTS.paymentMethod;
  var paymentArray = [];
  paymentArray.push(payment);
  return paymentArray;
};
var getCustomerInfo = function getCustomerInfo() {
  var customerInfo = _BigPointsCalculator.CustomerInfo;
  customerInfo.firstName = _constant.BPC_CONSTANTS.firstName;
  customerInfo.lastName = _constant.BPC_CONSTANTS.lastName;
  customerInfo.title = _constant.BPC_CONSTANTS.title;
  customerInfo.email = _constant.BPC_CONSTANTS.email;
  customerInfo.ssoId = _constant.BPC_CONSTANTS.constantId;
  customerInfo.bigLoyaltyId = _constant.BPC_CONSTANTS.bigLoyaltyId;
  customerInfo.customerIp = _constant.BPC_CONSTANTS.constantId;
  customerInfo.userCulture = _constant.BPC_CONSTANTS.culture;
  var phone = _BigPointsCalculator.Phone;
  phone.countryCode = _constant.BPC_CONSTANTS.constantId;
  phone.number = _constant.BPC_CONSTANTS.constantId;
  customerInfo.phone = phone;
  return customerInfo;
};
var getOrderData = function getOrderData(currency, totalAmount, baseFare, tax) {
  var order = _BigPointsCalculator.Order;
  var yourDate = new Date();
  order.createdAt = yourDate.toISOString();
  order.orderId = _constant.BPC_CONSTANTS.orderId;
  order.status = _constant.BPC_CONSTANTS.status;
  order.orderType = _constant.BPC_CONSTANTS.orderType;
  order.customerInfo = getCustomerInfo();
  order.fare = getFare(currency, totalAmount, baseFare, tax);
  order.payments = getPaymentInfo(currency, totalAmount);
  return order;
};
var getBigLoyaltyData = function getBigLoyaltyData(numberOfPassengers) {
  var bigLoyaltyIdsArray = [];
  for (var i = 0; i < numberOfPassengers; i++) {
    var bigLoyaltyId = _BigPointsCalculator.BigLoyaltyIds;
    bigLoyaltyId.bigLoyaltyId = _constant.BPC_CONSTANTS.constantId;
    bigLoyaltyId.memberTier = _constant.BPC_CONSTANTS.memberTier;
    bigLoyaltyIdsArray.push(bigLoyaltyId);
  }
  return bigLoyaltyIdsArray;
};
var getBpcRequest = function getBpcRequest(numberOfPassengers, currency, totalAmount, baseFare, tax) {
  var bpcRequest = _BigPointsCalculator.BpcRequest;
  bpcRequest.order = getOrderData(currency, totalAmount, baseFare, tax);
  bpcRequest.bigLoyaltyIds = getBigLoyaltyData(numberOfPassengers);
  return bpcRequest;
};
var callBpCalculator = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(url, header, body) {
    var response, message;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return _utilities.default.post(url, header, body);
        case 2:
          response = _context.sent;
          if (!(response === null)) {
            _context.next = 6;
            break;
          }
          message = {
            message: "An error has occured: ".concat(response.status)
          };
          throw new Error(message);
        case 6:
          return _context.abrupt("return", response);
        case 7:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function callBpCalculator(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
var usePrevious = function usePrevious(value) {
  var ref = (0, _react.useRef)();
  (0, _react.useEffect)(function () {
    ref.current = value;
  });
  return ref.current;
};
var BigPointsCalculatorContext = /*#__PURE__*/_react.default.createContext({});
exports.BigPointsCalculatorContext = BigPointsCalculatorContext;
var BigPointsCalculator = function BigPointsCalculator(props) {
  var _useState = (0, _react.useState)(_constant.ZERO_PRICE),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    points = _useState2[0],
    setPoints = _useState2[1];
  var environment = props.environment,
    authToken = props.authToken,
    numberOfPassengers = props.numberOfPassengers,
    currency = props.currency,
    baseFare = props.baseFare,
    tax = props.tax,
    totalAmount = props.totalAmount,
    children = props.children;
  var requestBody = getBpcRequest(numberOfPassengers, currency, totalAmount, baseFare, tax);
  var requestHeader = {
    'Content-Type': 'application/json',
    Authorization: "Bearer ".concat(authToken)
  };
  var requestUrl = _constant.ENVIRONMENT_URL[environment].BPC_URL;
  var refreshPoints = function refreshPoints() {
    callBpCalculator(requestUrl, requestHeader, requestBody).then(function (result) {
      if (result.points !== undefined && result.points.length !== 0 && result.points[0].pointsEntitled !== undefined) {
        setPoints(result.points[0].pointsEntitled);
      } else {
        // console.log('big points not found. response: ', result);
      }
    }).catch(function () {
      // console.log('error calling BPC: ', error);
    });
  };
  var previous = usePrevious({
    baseFare: baseFare,
    tax: tax,
    totalAmount: totalAmount,
    numberOfPassengers: numberOfPassengers,
    authToken: authToken,
    currency: currency,
    environment: environment
  });
  if (previous) {
    if (previous.baseFare !== baseFare || previous.tax !== tax || previous.totalAmount !== totalAmount || previous.numberOfPassengers !== numberOfPassengers || previous.currency !== currency) {
      refreshPoints();
    }
  } else {
    refreshPoints();
  }
  return /*#__PURE__*/_react.default.createElement(BigPointsCalculatorContext.Provider, {
    value: {
      points: points
    }
  }, children);
};
BigPointsCalculator.propTypes = _BigPointsCalculator.default.PropTypes;
BigPointsCalculator.defaultProps = _BigPointsCalculator.default.defaultProps;
var useBigPointsCalculatorContext = function useBigPointsCalculatorContext() {
  return (0, _react.useContext)(BigPointsCalculatorContext);
};
exports.useBigPointsCalculatorContext = useBigPointsCalculatorContext;
var _default = BigPointsCalculator;
exports.default = _default;